import { render } from "./App.vue?vue&type=template&id=60f45966"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=60f45966&lang=scss"

import exportComponent from "../.yarn/__virtual__/vue-loader-virtual-7c0eacfc91/0/cache/vue-loader-npm-17.4.2-00674d01e5-2b5a15858e.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__